import { React } from 'react';
import { ArtistsTitle, SubTitle, CHTextBox } from "./Artists"
import styled, { css } from 'styled-components'
import { ReadLess, aws_cloudfront_domain_name, GetS3CloudFrontJson } from '../../common/commonUtils';
import Header from '../navigation/Header';
import Footer from '../footer/Footer';
import Stack from '@mui/material/Stack';
import InstagramIcon from '@mui/icons-material/Instagram';
import "./Artists.css"

function getQueryStringKeysAndValues() {
    return window.location.href.split("?")[1].split(",").map(pair => pair.split("="));
}

function Body(props) {
    let instagramSection = null;
    if (props.igHandle && props.igHandle !== '') {
        instagramSection = (
            <Stack className='artist-contact-info-read-more' direction="row" spacing={2}>
                <InstagramIcon />
                <a style={{ textDecoration: 'none', color: 'black' }} href={`https://www.instagram.com/${props.igHandle}/`}>
                    @{props.igHandle}
                </a>
            </Stack>
        );
    }

    return (
        <div>
            <ArtistsTitle />
            <SubTitle title={props.artistName} />
            <img
                className='read-more-artist-image'
                src={aws_cloudfront_domain_name + "/artists/" + props.artistPicture}
                alt={props.artistName}
            />
            {instagramSection}
            <CHTextBox
                className='artist-bio-text-box'
                head={props.bioHead}
                body={props.bioBody}
                tail={props.bioTail}
            />
            <ReadLess page="team" />
        </div>
    )
}

export default function ArtistReadMorePage() {
    const artists = GetS3CloudFrontJson({ filePath: "https://d1tpjvssbtzmqj.cloudfront.net/artists.json" })
    const owners = GetS3CloudFrontJson({ filePath: "https://d1tpjvssbtzmqj.cloudfront.net/owners.json" })

    const artistKey = getQueryStringKeysAndValues()[0][1];
    const allArtists = { ...owners, ...artists };
    const artist = allArtists[artistKey]

    const artistName = artist ? artist.name : ''
    const artistPicture = artist ? artist.picture : ''
    const igHandle = artist ? artist.ig_handle : ''
    const bioHead = artist && artist.bio ? artist.bio.head : ''
    const bioBody = artist && artist.bio ? artist.bio.body : ''
    const bioTail = artist && artist.bio ? artist.bio.tail : ''

    const Container = styled.div`
        ${css`
            display: flex;
            min-width: 100vw;
            min-height: 100vh;
            flex-direction: column;
            justify-content: space-between;
            position: relative;
            z-index: 0;

            /* Fixed, Blurred, Hardware-Accelerated Layer */
            &::before {
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url("${aws_cloudfront_domain_name + '/artists/' + artistPicture}") no-repeat center center;
                background-size: cover;
                filter: blur(8px) brightness(0.95);
                z-index: -2;
                transform: translateZ(0);
            }

            /* Semi-transparent Overlay Layer */
            &::after {
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(rgba(255,255,255,.7), rgba(255,255,255,.7));
                z-index: -1;
            }
        `}
    `;

    return (
        <Container>
            <Header />
            <Body
                artistName={artistName}
                artistPicture={artistPicture}
                igHandle={igHandle}
                bioHead={bioHead}
                bioBody={bioBody}
                bioTail={bioTail}
            />
            <Footer />
        </Container>
    )
}